import {AutoTableController} from './auto-table';

class UserConfig {
    Vue;
    STORAGE_KEY = 'UserConfig';
    userConfig = null;

    constructor(Vue, $storage) {
        this.Vue = Vue
        this.userConfig = $storage.get(this.STORAGE_KEY)
    }

    async init() {
        // this.Vue.prototype.$lv.$storage.set(this.STORAGE_KEY, null)
        if (this.userConfig == null) {
            let {result, success} = await this.Vue.prototype.$http.post('action/userConfig/getUserConfig')
            if (!success) {
                this.$message.error(result)
                result = {}
            }
            this.Vue.prototype.$lv.$storage.set(this.STORAGE_KEY, result)
            this.userConfig = result
            await this.Vue.prototype.$lv.nextTick()
            !this.userConfig.tableConfigs && (this.userConfig.tableConfigs = {})
            AutoTableController.tables.forEach(autoTable => !!this.userConfig.tableConfigs[autoTable.tableConfig.id] && autoTable.refreshRender())
        }
        // console.log('初始化用户配置信息：', this.userConfig)
    }

    /**
     * 本地缓存userConfig，并不发送请求保存的服务器，因为userConfig可能会很大，所以要更新的话，请针对部分内容以及增加对应接口部分更新
     * @author  韦胜健
     * @date    2019/4/18 10:37
     */
    saveUserConfig() {
        this.Vue.prototype.$lv.$storage.set(this.STORAGE_KEY, this.userConfig)
    }

    async deleteUserConfig() {
        await this.Vue.prototype.$http.post('action/userConfig/deleteUserConfig')
        this.Vue.prototype.$dialog.show(LinkVue.$t('global.deleteSuccessful'))
        this.Vue.prototype.$lv.$storage.set(this.STORAGE_KEY, null)
    }

    getUserConfig() {
        if (!!this.userConfig) {
            !this.userConfig.tableConfigs && (this.userConfig.tableConfigs = {})
            return this.userConfig
        } else {
            return {tableConfigs: {}}
        }
    }
}

export default UserConfig
